module.exports = __webpack_public_path__ + "img/travel.b3adc30c.png";